const WS = "ws://"
const HTTP = "http://"

const BASE_URL_PROD = "www.civii.co:1023/civiiChat"
const BASE_URL_TEST = "10.125.30.120:1023/civiiChat"
const BASE_URL_DEV = "localhost:1023/civiiChat"

var BASE_URL = BASE_URL_PROD

let host = window.location.hostname
host = host.toLowerCase()

if (host.includes("10.125.30.120")) {
    BASE_URL = BASE_URL_TEST
} else if (host.includes("localhost") || host.includes("127.0.0.1")){
    BASE_URL = BASE_URL_DEV
}

export const ENDPOINT_CIVII_CHAT_USER_CHANNEL = `${WS}${BASE_URL}/usuario`;

export const ENDPOINT_ACCEPT_TERMS_AND_CONDITIONS = `${HTTP}${BASE_URL}/conversacion/aceptarTerminosYCondiciones`;
export const ENDPOINT_REJECT_TERMS_AND_CONDITIONS = `${HTTP}${BASE_URL}/conversacion/rechazarTerminosYCondiciones`;


// WEBPACK FOOTER //
// ./src/civii-chat/scripts/civiiChatUrls.js